import React from 'react';

const Navbar = ({ theme, toggleTheme }) => {
  return (
    <nav className={`fixed top-0 inset-x-0 z-50 apple-blur border-b transition-colors duration-500 ${theme === 'dark' ? 'bg-black/80 border-zinc-900' : 'bg-white/80 border-zinc-200'}`}>
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className={`w-6 h-6 rounded-sm transition-colors duration-500 ${theme === 'dark' ? 'bg-white' : 'bg-black'}`}></div>
          <span className={`font-black text-xl tracking-tighter uppercase ${theme === 'dark' ? 'text-white' : 'text-black'}`}>Kypser</span>
        </div>

        <div className="hidden md:flex items-center gap-12">
          <a href="#features" className={`text-xs font-bold uppercase tracking-widest transition-colors ${theme === 'dark' ? 'text-zinc-400 hover:text-white' : 'text-zinc-500 hover:text-black'}`}>Intelligence</a>
          <a href="#platform" className={`text-xs font-bold uppercase tracking-widest transition-colors ${theme === 'dark' ? 'text-zinc-400 hover:text-white' : 'text-zinc-500 hover:text-black'}`}>Platform</a>
          <a href="#who" className={`text-xs font-bold uppercase tracking-widest transition-colors ${theme === 'dark' ? 'text-zinc-400 hover:text-white' : 'text-zinc-500 hover:text-black'}`}>Enterprise</a>
        </div>

        <div className="flex items-center gap-6">
          <button
            onClick={toggleTheme}
            className={`p-2 rounded-full transition-colors ${theme === 'dark' ? 'text-zinc-400 hover:text-white' : 'text-zinc-500 hover:text-black'}`}
            title="Toggle Theme"
          >
            {theme === 'dark' ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5" /><line x1="12" y1="1" x2="12" y2="3" /><line x1="12" y1="21" x2="12" y2="23" /><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" /><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" /><line x1="1" y1="12" x2="3" y2="12" /><line x1="21" y1="12" x2="23" y2="12" /><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" /><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" /></svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" /></svg>
            )}
          </button>
          <a href="mailto:info@kypser.com?subject=Join%20Kypser" className={`px-6 py-2.5 rounded-full text-xs font-bold uppercase tracking-widest hover:scale-105 transition-all ${theme === 'dark' ? 'bg-white text-black' : 'bg-black text-white shadow-md'}`}>
            Join
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
